<div id="app">
    <section class="section">
        <!-- <div class="banner" style="background-image: url(./assets/img/bg.png);"> -->

        <div class="container">
            <h1 class="page-heading">Welcome to Chettinad Link Broadband
                Services</h1>
            <!-- <p class="page-description text-center"
            style="max-width: 800px; margin: 0 auto 30px; color: white;">
            Chettinad Link is a trusted broadband service provider delivering
            high-speed internet to homes and businesses across Tamil Nadu.
            Our user portal allows customers to log in and manage their
            subscriptions, view usage details, upgrade plans, and recharge
            accounts securely.
            Whether you're using mobile or desktop, the portal is fully
            responsive and built for speed and convenience.
        </p> -->
            <div class="row">
                <div class="col-12 col-lg-8">
                    <div class="slider">
                        <div>
                            <img src="./assets/img/Header-OTT.png"
                                alt="First slide">
                        </div>
                        <div>
                            <img src="./assets/img/slider.webp" loading="lazy"
                                alt="Second slide">
                        </div>
                        <div>
                            <img src="./assets/img/s_img3.jpg" loading="lazy"
                                alt="Third slide">
                        </div>
                        <div>
                            <img src="./assets/img/s_img2.jpg" loading="lazy"
                                alt="fouth slide">
                        </div>
                        <div>
                            <img src="./assets/img/img.webp" loading="lazy"
                                alt="fifth slide">
                        </div>

                    </div>

                </div>
                <div class="col-12 col-lg-4">
                    <div class="main-bg">
                        <div class="card card-primary">
                            <div class="login-logo">
                                <img
                                    src="./assets/images/chettinad-link-logo.png">
                            </div>

                            <div class="card-body padding-0">
                                <p
                                    style="width: 100%;font-size: 80%;color: #dc3545;"></p>
                                <h3>Login to your account</h3>
                                <form [formGroup]="loginForm">
                                    <div class="form-group">
                                        <label for="username">Registered
                                            Mobile Number</label>
                                        <input id="user_name" type="text"
                                            class="form-control"
                                            formControlName="user_name"
                                            [disabled]="loginButton"
                                            autocomplete="off"
                                            placeholder="Registered Mobile Number"
                                            (keyup.enter)="onSubmit()">
                                    </div>
                                    <!-- <div class="form-group chekbox">
                                            <input type="checkbox" checked>
                                            <label for="password"
                                                class="chekbox-label">Remember
                                                Me</label>
                                        </div> -->
                                    <div class="form-group"
                                        (click)="onSubmit()">
                                        <input type="button" value="Submit"
                                            class="btn btn-primary btn-lg btn-block login-btn">
                                    </div>
                                </form>
                                <p>{{ message }}</p>
                                <!-- <div class="display-space-between">
                                        <a href="#">Privacy Policy</a>
                                        <a href="#">Terms & Condition</a>
                                    </div> -->
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="footer">
                <div class="footer-bg"
                    style="background-image: url(./assets/img/ftbg.png);"></div>
                <div class="footer-section">
                    <span>
                        <a href="javascript:;"><img
                                src="./assets/img/facebook.png"
                                alt="icon"></a>
                    </span>

                    <span>
                        <a href="javascript:"><img
                                src="./assets/img/twitter.png"
                                alt="icon"></a>
                    </span>
                    <span>
                        <a href="javascript:"><img
                                src="./assets/img/instagram.png"
                                alt="icon"></a>
                    </span>
                    <span>
                        <a href="javascript:"><img
                                src="./assets/img/youtube.png"
                                alt="icon"></a>
                    </span>
                    <p>Copyright © {{currentYear}} Chettinad Link | <a
                            href="https://chettinadlink.com/">
                            by Chettinad Link</a></p>
                </div>

            </div>
        </div>

    </section>
</div>

<!-- OTP Modal (popup) -->
<div class="modal" id="otpModal" tabindex="-1" role="dialog"
    [ngStyle]="{ display: otpModalVisible ? 'block' : 'none' }">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <div class="form-side">
                    <div class="close-btn">
                        <button type="button" aria-label="Close"
                            (click)="closeOtpModal()">
                            <span class="close"
                                aria-hidden="true">X</span>
                        </button>
                    </div>
                </div>
                <div class="split-form">
                    <div class="image-side">
                        <img src="./assets/images/bg3.jpg" alt="banner">
                        <!-- <img src="./assets/img/left.jpg" alt="banner"> -->
                    </div>
                    <div class="form-side">
                        <div class="form-section">
                            <form [formGroup]="otpForm">
                                <div class="form-group">
                                    <img
                                        src="https://cdn-icons-png.flaticon.com/512/10464/10464776.png"
                                        alt="Lock Icon">
                                    <h3>Two-Factor Authentication</h3>
                                    <p class="info">An OTP has been sent to
                                        <span> your Mobile/Email</span></p>
                                    <div formArrayName="otp"
                                        class="otp-box-group">
                                        <div
                                            *ngFor="let control of otpForm.get('otp')['controls']; let i = index">
                                            <input type="tel"
                                                inputmode="numeric"
                                                maxlength="1"
                                                class="otp-input"
                                                [formControlName]="i"
                                                (keyup)="onOtpKeyUp($event, i)"
                                                (keyup.enter)="verifyOTP()"
                                                autocomplete="one-time-code"
                                                pattern="[0-9]*"
                                                #firstOtpInput
                                                *ngIf="i === 0; else otherOtpInputs">
                                            <ng-template #otherOtpInputs>
                                                <input type="tel"
                                                    inputmode="numeric"
                                                    maxlength="1"
                                                    class="otp-input"
                                                    [formControlName]="i"
                                                    (keyup)="onOtpKeyUp($event, i)"
                                                    (keyup.enter)="verifyOTP()"
                                                    autocomplete="one-time-code"
                                                    pattern="[0-9]*">
                                            </ng-template>

                                        </div>
                                    </div>

                                    <!-- Timer display -->
                                    <div class="resend_timer" *ngIf="showTimer">
                                        <p>Resend OTP in {{ timerDisplay
                                            }}</p>
                                    </div>

                                    <!-- Resend button only shows after timer ends -->
                                    <div *ngIf="!showTimer">
                                        <a class="resend_otp"
                                            style="cursor: pointer;"
                                            (click)="resendOTP()">Resend</a>
                                    </div>

                                </div>
                                <div class="form-group">
                                    <input type="button"
                                        (click)="verifyOTP()"
                                        value="Submit OTP"
                                        class="btn btn-primary btn-lg btn-block">
                                </div>
                                <!-- <p class="error"
                                    *ngIf="otpHasEmptyField()">{{ message1
                                    }}</p>
                                <p class="error" *ngIf="message ">{{ message
                                    }}</p> -->

                                <p class="error"
                                    *ngIf="otpHasEmptyField() || message?.trim()">{{
                                    otpHasEmptyField() ? message1 : message
                                    }}</p>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
